import React, { Component } from "react";
import keyCodes from "../../commonjs/keyCodes";
import keyListener from '../../commonjs/keyListener';
import $ from 'jquery';
export default class ScrollView extends Component {
   
    constructor(props) {
        super(props);
        this.state = {
            sTop:0,
            showMask: false,
        }
    }

    componentDidMount() {
        //初始化焦点
        keyListener.set(this.handleKeyDownKey, this.handleKeyUp);
    }

    thisY = 0
    handleKeyDownKey = (keyCode) => {
        let thisH = document.getElementById("scrollBox").clientHeight;
        let content = document.getElementById("agreementList").clientHeight;
        console.log(thisH)
        if (keyCode === keyCodes.up) {
            if (this.thisY >= content) {
                this.thisY = this.thisY - 300;
            } else {
                this.thisY = 0;
            }
        } else if (keyCode === keyCodes.down) {

            if (this.thisY < thisH - content) {
                this.thisY = this.thisY + 300;
            } else if (this.thisY > thisH) {
                this.thisY = this.thisY;
            }
        }
        if (keyCode == keyCodes.down || keyCode === keyCodes.up) {
            console.log('-------'+this.thisY)
            $(".agreementList").scrollTop(this.thisY);
        }
    }


    componentWillUnmount() {
        // 组件销毁后，按键置空，归还上级
        keyListener.set(null);

    }

    render() {
        return (
            <div className="scrollBox scrollBox_bj">
                <div id="agreementList" className="agreementList">
                    { this.props.children }
                </div>
                <div className='bottomMask'></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/newEra/ScrollView.js